// The coach colors and the coach chip of the block cards, shared by the Schedule tab and the block dialog.
import { Tooltip } from "antd";
import { FORMER_STAFF, getInitials } from "@utils/rtp_utils";
import type { RtpPlanDetail } from "./types";

// Card accent per coach (the block creator): the left border and the initials chip.
// Ordered so the first coaches on a plan get the most distinct hues; the first is the Whistle
// brand orange (#F15923, as on the Whistle AI button). The UI accent blue
// (#1677ff — buttons, selection, today) goes last, so a coach color rarely reads as "selected".
export const COACH_COLORS = [
	"#F15923",
	"#389e0d",
	"#eb2f96",
	"#13a8a8",
	"#722ed1",
	"#d4a106",
	"#2f54eb",
	"#c41d7f",
	"#7cb305",
	"#08979c",
	"#ad6800",
	"#531dab",
	"#cf1322",
	"#0958d9",
	"#5b8c00",
	"#9e1068",
	"#006d75",
	"#874d00",
	"#d4380d",
	"#1677ff",
];

// Colors go out in order of each coach's first block on the plan (lowest block id). A coach
// who joins later gets the next color, so existing coaches never change color.
export function coachColors(plan: RtpPlanDetail): Record<string, string> {
	const creators = plan.phases
		.flatMap((phase) => phase.blocks)
		.sort((a, b) => a.id - b.id)
		.map((block) => block.createdBy);
	const colors: Record<string, string> = {};
	for (const uuid of creators) {
		if (!(uuid in colors)) colors[uuid] = COACH_COLORS[Object.keys(colors).length % COACH_COLORS.length];
	}
	return colors;
}

// The coach chip: the initials in the coach color on a light tint of it, with the full name in the
// tooltip. A missing creator shows as Former staff.
export const CreatorChip = ({ creator, color }: { creator?: string; color: string }) => {
	const name = creator?.trim() || FORMER_STAFF;
	return (
		<Tooltip title={name}>
			<span
				className="rtp-block-creator"
				aria-label={`Created by ${name}`}
				// 1f = ~12% alpha: a light tint of the coach color behind the initials.
				style={{ background: `${color}1f`, color }}
			>
				{getInitials(name)}
			</span>
		</Tooltip>
	);
};
